import { SearchPageChrome } from "@/components/search/page-chrome"
import { ShortlistRenameDialog } from "@/components/search/shortlists/rename-dialog"
import {
  ShortlistWorkspaceTabs,
  type ShortlistWorkspaceTab,
} from "@/components/search/shortlists/workspace-tabs"
import { Card } from "@/components/ui/card"
import { PageBody } from "@/components/ui/layout"
import type SearchShortlistsShortlistWorkspace from "@/types/serializers/SearchShortlistsShortlistWorkspace"

type ShortlistedSearchWorkspaceProps = {
  shortlist: SearchShortlistsShortlistWorkspace
  activeTab: ShortlistWorkspaceTab
  sidebar: React.ReactNode
  topControls?: React.ReactNode
  results: React.ReactNode
}

/**
 * The shell both shortlist tab pages render: Search › Shortlists ›
 * Shortlist, with the shortlist's name as the identity, then the tabs with
 * their counts and the rename action around that tab's sidebar and results.
 */
export function ShortlistedSearchWorkspace({
  shortlist,
  activeTab,
  sidebar,
  topControls,
  results,
}: ShortlistedSearchWorkspaceProps) {
  return (
    <>
      <SearchPageChrome identity={{ name: shortlist.name }} />
      <PageBody>
        <Card>
          <div
            className="flex min-h-0 flex-col sm:flex-row"
            data-testid="shortlist-workspace"
          >
            {sidebar}
            <div className="flex flex-1 flex-col gap-4 p-6">
              <div className="flex flex-wrap items-center justify-between gap-4">
                <ShortlistWorkspaceTabs
                  active={activeTab}
                  shortlist={shortlist}
                />
                {/* Rename keeps to the right when the row wraps. */}
                <div className="ml-auto">
                  <ShortlistRenameDialog shortlist={shortlist} />
                </div>
              </div>
              {topControls}
              {results}
            </div>
          </div>
        </Card>
      </PageBody>
    </>
  )
}
